<template>
  <div>
    <el-container class="loginPage">
        <el-row style="width: 1200px; margin: 0 auto; margin-top: 200px;">
            <el-col :span="6" style="color: #fff;">

                <el-row>
                    <el-col class="help-item" :span="24" @click.native="openShiPin()">
                        <el-row style="display: flex;align-items: center;">
                            <el-col :span="6">
                                <el-icon class="el-icon-video-camera" style="font-size: 30px;"></el-icon>
                            </el-col>
                            <el-col :span="18">
                                <div>
                                    <h3>操作视频</h3>
                                    <div>查看各功能讲解视频</div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>

                    <el-col class="help-item" @click.native="openShouCe()" :span="24">
                        <el-row style="display: flex;align-items: center;">
                            <el-col :span="6">
                                <el-icon class="el-icon-document" style="font-size: 30px;"></el-icon>
                            </el-col>
                            <el-col :span="18">
                                <div>
                                    <h3>操作手册</h3>
                                    <div>查看各功能操作手册</div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col class="help-item" @click.native="downloadChangJianWenTi()" :span="24">
                        <el-row style="display: flex;align-items: center;">
                            <el-col :span="6">
                                <el-icon class="el-icon-s-opportunity" style="font-size: 30px;"></el-icon>
                            </el-col>
                            <el-col :span="18">
                                <div>
                                    <h3>常见问题</h3>
                                    <div>查看常见问题</div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="12" style="position: relative;">
                <el-main class="main" style="position: relative;">
                  <div class="titleText">河北省计量业务应用平台</div>
                    <div v-show="!isShowSelf">
<!--                        <div v-if="loginData.mode === 'QR_CODE_LOGIN'"-->
<!--                             style="position: absolute;top: 5px;right: 5px;cursor: pointer;z-index: 1"-->
<!--                             @click="switchLoginMode('USER_NAME')">-->
<!--                            <i class="iconfont icondiannao1" style="font-size: 50px;color: #FFFFFF"></i>-->
<!--                        </div>-->
<!--                        <div v-else style="position: absolute;top: 5px;right: 5px;cursor: pointer; z-index: 1"-->
<!--                             @click="switchLoginMode('QR_CODE_LOGIN')">-->
<!--                            <i class="iconfont iconerweima" style="font-size: 50px;color: #FFFFFF"></i>-->
<!--                        </div>-->
                        <div class="rightBottom" v-if="loginData.mode === 'QR_CODE_LOGIN'"
                             @click="switchLoginMode('USER_NAME')"><i
                            class="iconfont iconfanhui"></i><span>&nbsp;账号登录</span></div>

                        <template v-if="loginData.mode === 'QR_CODE_LOGIN'">
                            <wx-login appid="wx1c52839e81b3014a" scope="snsapi_login" theme="black"
                                      :redirect_uri='encodeURIComponent("https://jlyw.hebjlzy.com/wechat/authorize")'
                                      href="data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDI1MHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyNTBweDtjb2xvcjogI2ZmZjt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30g">
                            </wx-login>
                        </template>
                        <template v-else>
                            <el-form ref="form_login"
                                     label-position="left"
                                     :rules="rules"
                                     label-width="0px"
                                     :model="loginData"
                            >
                                <el-tabs v-model="loginData.mode">
                                    <el-tab-pane label="用户名登录" name="USER_NAME">
                                        <template v-if="loginData.mode === 'USER_NAME'">
                                            <el-form-item prop="name" class="">
                                                <el-input placeholder="请输入统一社会信用代码或身份证号"
                                                          prefix-icon="iconfont iconlui-sys-user"
                                                          @keyup.enter.native="checkLoginForm('form_login')"
                                                          v-model.trim="loginData.name">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item prop="pwd" class="" style="position:relative;">
                                                <el-input placeholder="请输入密码"
                                                          prefix-icon="iconfont iconzu"
                                                          show-password
                                                          @keyup.enter.native="checkLoginForm('form_login')"
                                                          v-model.trim="loginData.pwd">
                                                </el-input>
                                                <span class="sjj-login" @click="toSJJLogin()"> 市监局用户登录 </span>
                                                <span class="nopsw" @click="forgetDialog = true" style="right: 80px;">忘记密码 ？</span>
                                                <span class="nopsw" @click="goChangeApply()">单位变更</span>
                                            </el-form-item>
                                        </template>

                                    </el-tab-pane>
                                    <el-tab-pane label="手机号登录" name="MOBILE">
                                        <template v-if="loginData.mode === 'MOBILE'">
                                            <el-form-item prop="mobile">
                                                <el-input placeholder="请输入手机号"
                                                          prefix-icon="iconfont iconlui-sys-user"
                                                          @keyup.enter.native="checkLoginForm('form_login')"
                                                          v-model.trim="loginData.mobile">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item prop="code">
                                                <el-input class="btn" placeholder="请输入短信验证码"
                                                          v-model.trim="loginData.code"
                                                          @keyup.enter.native="checkLoginForm('form_login')">
                                                    <template slot="append">
                                                        <el-button class="sms"
                                                                   style="background-color: #34a1db;color: #fff;"
                                                                   type="primary"
                                                                   @click="checkMobile('form_login')"
                                                                   :disabled="!isSend"> {{ smsInterval }}
                                                        </el-button>
                                                    </template>
                                                </el-input>
                                            </el-form-item>
                                        </template>
                                    </el-tab-pane>
<!--                                    <el-tab-pane label="二维码登录" name="QR_CODE_LOGIN"></el-tab-pane>-->
                                </el-tabs>
                            </el-form>
                            <div class="btnBox">
                                <el-button type="primary"
                                           class="btn"
                                           v-loading.fullscreen.lock="loading"
                                           @click="checkLoginForm('form_login')"
                                >登录
                                </el-button>
                                <a href="/register-user" class="register" target="_blank">个人注册</a>
                                <span
                                    style="color: #ff4949; font-size: 14px;"> *建议使用谷歌或火狐浏览器较新版本访问 </span>
                                <a href="/register-company-select" class="regist-company" target="_blank">单位注册</a>
                            </div>
                        </template>


                        <!--        忘记密码-->
                        <el-dialog v-dialogDrag title="忘记密码" :visible.sync="forgetDialog" width="500px"
                                   append-to-body @closed="resetForgetForm">
                            <el-form @submit.native.prevent label-width="80px" ref="form" :rules="rules2"
                                     :model="forgetForm">
                                <el-form-item label="手机号" prop="phone">
                                    <el-input placeholder="手机号" size="mini" v-model="forgetForm.phone"></el-input>
                                </el-form-item>
                                <el-form-item label="用户名" prop="name">
                                    <el-input placeholder="用户名" size="mini" v-model="forgetForm.name"></el-input>
                                </el-form-item>
                                <el-form-item label="验证码" prop="code">
                                    <el-input placeholder="短信验证码" size="mini" v-model="forgetForm.code">
                                        <el-button slot="append" :disabled="!isForgetSmsSend"
                                                   @click="checkForgetPassForm">
                                            {{ forgetSmsInterval }}
                                        </el-button>
                                    </el-input>
                                </el-form-item>
                                <el-form-item v-if="forgetNewPassword" label="新密码">
                                    <el-input size="mini" type="text" :value="forgetNewPassword" readonly></el-input>
                                </el-form-item>
                                <div style="text-align: right">
                                    <el-link type="primary" style="font-size: 12px;" @click="goChangeMobile">
                                        手机号不可用?
                                    </el-link>
                                </div>
                            </el-form>
                            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="forgetDialog = false">取 消</el-button>
                <el-button type="primary" size="mini" :disabled="!!forgetNewPassword"
                           @click="saveBtn()">验证并重置</el-button>
            </span>
                        </el-dialog>
                    </div>
                      <slide-captcha ref="slideCaptcha" :visible.sync="isShowSelf" append-to-body
                                     @success="onCaptchaSuccess"></slide-captcha>
                </el-main>
            </el-col>
            <el-col :span="6" style="color: #fff;">
                <el-row>

                    <el-col class="help-item" @click.native="toZhiNengWenDa()" :span="24">
                        <el-row style="display: flex;align-items: center;">
                            <el-col :span="6">
                                <el-icon class="el-icon-headset" style="font-size: 30px;"></el-icon>
                            </el-col>
                            <el-col :span="18">
                                <h3>智能问答</h3>
                                <div>快速获取答案</div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col class="help-item" @click.native="zixunDialog=true" :span="24">
                        <el-row style="display: flex;align-items: center;">
                            <el-col :span="6">
                                <el-icon class="el-icon-phone" style="font-size: 30px;"></el-icon>
                            </el-col>
                            <el-col :span="18">
                                <h3>咨询电话</h3>
                                <div>0311-88606635</div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col class="help-item" @click.native="zixunDialog=true" :span="24">
                        <el-row style="display: flex;align-items: center; height: 80px;">
                            <el-col :span="6">
                                <el-icon class="el-icon-alarm-clock" style="font-size: 30px;"></el-icon>
                            </el-col>
                            <el-col :span="18">
                                <h3>咨询时间(工作日)</h3>
                                <div style="font-size: 14px;">08:30-12:00/14:30-17:30</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

            </el-col>

        </el-row>
        <el-footer>
            <span>技术支持：河北省计量检测技术中心</span>
            <span>咨询电话：0311-88606635</span>
            <span><a href="https://beian.miit.gov.cn" style="color: #fff;" target="_blank">冀ICP备19028735号-3</a></span>
        </el-footer>

        <div style="position: absolute;bottom: 1%;left: 3%;">
            <img src="../../static/image/gzh.jpg" width="100" height="100"/>
            <div style="text-align:center;margin: 6px auto;font-family: 微软雅黑;font-size: 14px;color: #FFF;"> 微信公众号</div>
        </div>
        <div style="position: absolute;top: 15px;right: 250px;">
            <el-link style="font-size: 15px;color: #FFF" type="text" @click="toGongXiangPingTai()">
                河北省计量资源共享服务平台
            </el-link>
        </div>
      <div style="position: absolute;top: 15px;right: 40px;">
        <el-link style="font-size: 15px;color: #FFF" type="text" @click="toGongZhongChaXun()">
          强制检定信息公众查询系统
        </el-link>
      </div>

        <div class="loading-next" v-show="newLoadingShow">
            <div class="loading-next-box">
                <div class="loading-next-box-warp">
                    <div class="loading-next-box-item"></div>
                    <div class="loading-next-box-item"></div>
                    <div class="loading-next-box-item"></div>
                    <div class="loading-next-box-item"></div>
                    <div class="loading-next-box-item"></div>
                    <div class="loading-next-box-item"></div>
                    <div class="loading-next-box-item"></div>
                    <div class="loading-next-box-item"></div>
                    <div class="loading-next-box-item"></div>
                </div>
            </div>
        </div>


<!--      <el-alert  style="width: 440px; position: absolute; right: 1%; bottom: 8%">-->
<!--        <template #title>-->
<!--          <span style="font-size: 18px; font-weight: 700;color: #000000; text-align: center; display: block;"> 平台域名升级通知 </span>-->
<!--        </template>-->
<!--        <template #default>-->
<!--          <div style="font-size: 14px;line-height: 20px;">-->
<!--            <p> 尊敬的平台用户：</p>-->
<!--            <p style="text-indent: 2em;">-->
<!--              为进一步保障您的账户安全与数据隐私，平台已完成域名安全升级，现在平台访问地址为：<a href="https://jlyw.hebjlzy.com/login">https://jlyw.hebjlzy.com/login</a>。请各位用户知晓，由此带来的不便敬请谅解！-->
<!--            </p>-->
<!--            <div style="text-align: right">-->
<!--              <p> 河北省计量业务应用平台 </p>-->
<!--              <p> 2026年4月30日</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-alert>-->


        <el-dialog title="咨询服务" :visible.sync="zixunDialog" width="480px" append-to-body>
            <div style="line-height: 30px">
                <el-row><el-col :span="8" style="text-align: right;"><b>咨询电话：</b></el-col><el-col :span="16">0311-88606635</el-col></el-row>
                <el-row><el-col :span="8" style="text-align: right;"><b>邮箱：</b></el-col><el-col :span="16">JLZXjishuke1@163.com</el-col></el-row>
                <el-row><el-col :span="8" style="text-align: right;"><b>咨询时间：</b><br><b>（工作日）</b></el-col><el-col :span="16">
                    <el-row><el-col :span="6" style="text-align: right;">夏令时：</el-col><el-col :span="18">08:30-12:00</el-col></el-row>
                    <el-row><el-col :span="6" style="text-align: right;">&nbsp;</el-col><el-col :span="18">14:30-17:30</el-col></el-row>
                    <el-row><el-col :span="6" style="text-align: right;">冬令时：</el-col><el-col :span="18">08:30-12:00</el-col></el-row>
                    <el-row><el-col :span="6" style="text-align: right;">&nbsp;</el-col><el-col :span="18">13:30-17:30</el-col></el-row>
                </el-col></el-row>

            </div>
        </el-dialog>

        <el-dialog title="手册列表" :visible.sync="shouceDialog" top="20px" width="480px" append-to-body>
            <div style="margin-left: 20px;">
                <div v-for="t in shouceList" :key="t.name" style="border-bottom: #cccccc 1px solid;">
                    <div style="font-size: 18px;font-weight: 700;" v-html="t.name">

                    </div>
                    <div style="margin-left: 10px;">
                        <template v-for="s in t.datas">
                            <el-row :key="s.name">
                                <el-col :span="12">
                                    <el-link type="primary" size="mini" style="font-size: 16px;margin: 5px;"
                                             @click="downloadShouCe(s)"> {{ s.name }}
                                    </el-link>
                                </el-col>
                                <el-col :span="5" v-if="s.videoUrl">
                                    <el-button type="primary" size="mini" icon="el-icon-video-camera-solid" circle
                                               @click="toVideo(s.videoUrl)"></el-button>
                                </el-col>
                            </el-row>
                        </template>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="操作视频列表" :visible.sync="shouceShiPin.dialog" top="20px" width="60%" append-to-body>
            <el-table :data="shouceShiPin.list">
                <el-table-column label="序号" type="index" :index="(index) => index + 1" width="50"
                                 align="center"></el-table-column>
                <el-table-column label="视 频（点击可查看）" prop="videoName">
                    <template #default="scope">
                        <el-link type="primary" size="mini" style="font-size: 16px;margin: 5px;"
                                 @click="toVideo(scope.row.videoUrl)"> {{ scope.row.videoName }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column label="视频内容" prop="content"></el-table-column>
                <el-table-column label="相关操作手册（点击可查看）">
                    <template #default="scope">
                        <div v-for="(sc, sIndex) in scope.row.shouCes" :key="'czsc-' + sIndex">
                            <el-link type="primary" size="mini" style="font-size: 16px;margin: 5px;"
                                     @click="downloadShouCe({name: sc})"> {{ sc }}
                            </el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </el-container>

  </div>
</template>

<style lang="scss">
.loginPage {
    background: url("../../static/image/login/bgimg.jpg") 50% no-repeat;
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .help-item {
        padding: 25px;

        .el-row {
            cursor: pointer;
            padding: 15px;
            background-color: rgba(255, 255, 255, 0.2);
        }

        h3 {
            line-height: 20px;
            margin: 5px 0;
        }
    }

    .right-help {
        position: absolute;
        height: 400px;
        left: 25%;
        bottom: 43%;
        margin-bottom: -170px;
        font-size: 18px;
        text-align: center;
        color: #fff;
        line-height: 50px;
    }

    .main {
        text-align: center;
        margin: 5px auto;
        height: 400px;
        width: 500px;
        position: absolute;
        background-image: url("../../static/image/login/bg2-img.png");
        background-size: 100% 100%;
        padding: 50px;
        padding-bottom: 70px;
        overflow: unset;

        .el-tabs {
            .el-tabs__item {
                color: #FFFFFF;
            }
        }

        .el-form-item {
            margin-bottom: 40px;
        }

        .title1 {
            margin: 0 auto 30px auto;
            text-align: center;
            font-size: 20px;
            color: #fff;
            font-size: 23px;
            font-weight: 500;
        }

        .el-input__inner {
            border: 1px solid #018ad2;
            background-color: rgba(0, 0, 0, 0) !important;
            color: #d1d6e6;
        }

        .el-input__icon, .el-input__prefix {
            height: 100%;
            text-align: center;
            -webkit-transition: all .3s;
            transition: all .3s;
            left: 8px;
        }

        .el-input__icon {
            width: 25px;
            line-height: 40px;
        }

        .btnBox {
            position: relative;
        }

        .regist-company {
            color: #018ad2;
            position: absolute;
            right: 0;
            top: 55px;
            font-size: 14px;
        }

        .register {
            color: #018ad2;
            position: absolute;
            left: 0;
            top: 55px;
            font-size: 14px;
        }

        .btn {
            width: 100%;
        }

        .sjj-login {
            position: absolute;
            bottom: -30px;
            left: 5px;
            color: #018ad2;
            font-size: 15px;
            line-height: 30px;
            cursor: pointer;
        }

        .nopsw {
            position: absolute;
            bottom: -30px;
            right: 5px;
            color: #018ad2;
            font-size: 15px;
            line-height: 30px;
            cursor: pointer;
        }

        .rightBottom {
            position: absolute;
            bottom: 15px;
            right: 15px;
            cursor: pointer;
            color: #aaa;
        }
    }

    /*标题*/
    .titleText {
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 34px;
        font-weight: bold;
        position: absolute;
        top: -80px;
        left: 0;
    }

    .el-footer {
        text-align: center;
        color: #fff;
        font-size: 12px;
        position: fixed;
        bottom: 7vh;
        left: 0;
        right: 0;
        font-size: 14px;

        > span {
            margin: 0 20px;
            line-height: 45px;
        }
    }

    /*    手册按钮*/
    .shouceBtn {
        /*background: url("../../static/image/login/shouce.png") 50% no-repeat;*/
        position: fixed;
        top: 0;
        left: 0;
        width: 100px;
        height: 100px;
        font-size: 35px;
        color: #fff;
        cursor: pointer;
        background-color: rgb(255, 105, 54);
        text-align: center;
        border-radius: 3px;
        padding-top: 5px;
    }


    @keyframes hzfirst {
        0% {
            background-color: #F40002
        }
        50% {
            background-color: rgba(8, 82, 173)
        }
        100% {
            background-color: #F40002
        }
    }

    .flashing {
        border: 1px solid transparent;
        /*默认背景颜色*/
        background-color: red;
        /*动画元素名-动画整个过程的时间*/
        animation: hzfirst 2s;
        /*动画次数*/
        animation-iteration-count: 60;
    }
}
</style>
<script>
import {mapMutations} from "vuex";
import {dictApi, mechanismApi, ssoApi, userApi} from "../api/organization";
import {TagsViewModule} from "../store/modules/tagsView";
import wxLogin from 'vue-wxlogin';
import '@/../static/css/loading.scss';
import baseUrl, {imageUrl} from "@/constants";
import SlideCaptcha from "@/components/SlideCaptcha.vue";

export default {
    name: "login",
    components: {
      SlideCaptcha,
        wxLogin
    },
    data() {
        return {
            showUpgradeDialog: true,
            isSend: true,
            isShowSelf: false,
            smsInterval: "发送验证码",
            forgetSmsInterval: "发送验证码",
            isForgetSmsSend: true,
            forgetNewPassword: "",
            forgetSmsTimer: null,
            captchaMode: '',
            loginData: {
                mode: "USER_NAME",
                mobile: "",
                token: "",
                code: "",
                name: "",
                pwd: ""
            },
            rules: {
                mobile: [
                  {required: true, message: "请输入手机号", trigger: "blur"},
                    {
                        validator: (rule, value, callback) => {
                          if (!value) {
                            callback(new Error("请输入手机号"));
                          } else if (!/^1[3456789]\d{9}$/.test(value)) {
                              callback(new Error("请输入正确的手机号"));
                          } else {
                              callback();
                          }
                        },
                        trigger: "blur"
                    }
                ],
                code: [{required: true, message: "请输入验证码", trigger: "blur"}],
                name: [{required: true, message: "请输入统一社会信用代码或身份证号", trigger: "blur"}],
                pwd: [{required: true, message: "请输入密码", trigger: "blur"}]
            },
            loading: false,
            rules2: {
                phone: [
                    {required: true, message: "请输入手机号", trigger: "blur"},
                    {pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号", trigger: "blur"}
                ],
                name: [{required: true, message: "请输入用户名", trigger: "blur"}],
                code: [{required: true, message: "请输入短信验证码", trigger: "blur"}]
            },
            forgetForm: {
                phone: "",
                name: "",
                token: "",
                code: ""
            },
            forgetDialog: false,

            positionX: 0,//初始横坐标
            positionY: 100,//初始纵坐标
            directX: 1,//移动时候的方向 1代表正方向右
            derectY: 1,//移动时候的方向 1代表正方向上

            shouceBtnSize: {
                w: 100,
                h: 100,
                x: 0,
                y: 0
            },
            screenHeight: document.documentElement.clientHeight, // 可见区域高度(应为body高度，可某些环境下无法获取)
            screenWidth: document.documentElement.clientWidth,
            ballMoveInterval: null,

            newLoadingShow: true,//新加载框显示

            zixunDialog: false,
            shouceDialog: false,
            shouceShiPin: {
                dialog: false,
                list: [
                    {
                        videoName: '使用须知（必看）',
                        videoUrl: '/public/video/%E4%BD%BF%E7%94%A8%E9%A1%BB%E7%9F%A5.mp4',
                        content: '介绍平台流程、使用前的准备工作',
                        shouCes: ['1 系统使用环境.pdf']
                    },
                    {
                        videoName: '账号注册及登陆',
                        videoUrl: '/public/video/%E8%B4%A6%E5%8F%B7%E6%B3%A8%E5%86%8C%E5%8F%8A%E7%99%BB%E5%BD%95.mp4',
                        content: '两类用户的注册、登陆方法；账号密码的找回操作',
                        shouCes: ['2 单位注册.pdf', '3 个人注册.pdf', '4 用户登录.pdf']
                    },
                    {
                        videoName: '绑定申请及审核',
                        videoUrl: '/public/video/%E7%BB%91%E5%AE%9A%E7%94%B3%E8%AF%B7%E5%8F%8A%E5%AE%A1%E6%A0%B8.mp4',
                        content: '两类用户注册完成后的绑定申请及审核',
                        shouCes: ['5 绑定单位申请.pdf', '6 绑定单位审核.pdf']
                    },
                    {
                        videoName: '计量器具台账建立',
                        videoUrl: '/public/video/%E8%AE%A1%E9%87%8F%E5%99%A8%E5%85%B7%E5%8F%B0%E8%B4%A6%E5%BB%BA%E7%AB%8B.mp4',
                        content: '两种添加方式：单个添加、批量倒入（选择一种即可），器具信息编辑修改',
                        shouCes: ['7 计量器具台账.pdf']
                    },
                    {
                        videoName: '备案申请',
                        videoUrl: '/public/video/%E5%A4%87%E6%A1%88%E7%94%B3%E8%AF%B7.mp4',
                        content: '备案申请操作、备案状态解读',
                        shouCes: ['8 器具备案申请.pdf']
                    },
                    {
                        videoName: '检定申请',
                        videoUrl: '/public/video/%E6%A3%80%E5%AE%9A%E7%94%B3%E8%AF%B7.mp4',
                        content: '检定申请操作、检定状态解读，“不受理”类型器具信息修改，单据导出，证书查看下载',
                        shouCes: ['9 器具检定申请.pdf']
                    },
                    {
                        videoName: '再次报检操作',
                        videoUrl: '/public/video/%E5%86%8D%E6%AC%A1%E6%8A%A5%E6%A3%80%E6%93%8D%E4%BD%9C.mp4',
                        content: '证书即将到期申请下一周期检定的操作',
                        shouCes: []
                    },
                ]
            },

            shouceList: [
                {
                    name: "通用部分", datas: [
                        {name: "1 系统使用环境.pdf", url: ""},
                        {name: "2 单位注册.pdf", url: ""},
                        {name: "3 个人注册.pdf", url: ""},
                        {name: "4 用户登录.pdf", url: ""},
                        {name: "5 绑定单位申请.pdf", url: ""},
                        {name: "6 绑定单位审核.pdf", url: ""}]
                },
                {
                    name: "企业部分", datas: [
                        {name: "7 计量器具台账.pdf", url: ""},
                        {name: "8 器具备案申请.pdf", url: ""},
                        {name: "9 器具检定申请.pdf", url: ""}]
                },
                {
                    name: "行政部分<span style='color: red;font-size: 16px;'>（企业勿做）</span>", datas: [
                        {name: "10 基础设置（行政）.pdf", url: ""},
                        {name: "11 备案办理.pdf", url: ""}]
                },
                {
                    name: "机构部分<span style='color: red;font-size: 16px;'>（企业勿做）</span>", datas: [
                        {name: "12 基础设置（机构）.pdf", url: ""},
                        {name: "13 检定办理.pdf", url: ""}]
                },
                {
                    name: "诚信计量操作手册", datas: [
                        {
                            name: "申报指南.pdf",
                            url: "",
                            videoUrl: '/public/video/%E8%AF%9A%E4%BF%A1%E8%AE%A1%E9%87%8F%E7%94%B3%E8%AF%B7%E5%8D%95%E4%BD%8D%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.mp4'
                        }]
                }
            ],
        }
    },
    created() {
        this.autologin();
        this.listRegion();
        this.startMove();
    },
    //生命周期销毁：
    destroyed() {
        // 清除定时器
        this.stopMove();
        if (this.forgetSmsTimer) {
            clearInterval(this.forgetSmsTimer);
        }
    },
    methods: {
        ...mapMutations(["changeLogin", "changeUserRight", "saveRegion"]),
        toSJJLogin() {
            window.open("https://sso.hebamr.cn/oauth2/authorize" +
                "?response_type=code" +
                "&client_id=1712670776057335808" +
                "&redirect_uri=" + encodeURI("https://jlyw.hebjlzy.com/sjj-authorize") +
                "&random_code=123456" +
                "&app_id=002023101370775772123136");
        },
        reload() {
            console.log('SliderVerify => reload')
        },
        show() {
            console.log('SliderVerify => show')
        },
        hide() {
            console.log('SliderVerify => hide')
        },
        success() {
            console.log('SliderVerify => success')
        },
        fail() {
            console.log('SliderVerify => fail')
        },
        //自动登录
        autologin() {
            if (this.$store.state.AuthedUser) {
                const appId = this.$route.query.appId;
                const returnUrl = this.$route.query.returnUrl;
                if (appId && returnUrl) {
                    this.getCode(appId, returnUrl);
                } else {
                    this.newLoadingShow = false;
                }
            } else {
                this.newLoadingShow = false;
            }
        },
        listRegion() {
            dictApi.listRegion().then((r) => {
                if (r.data.result === 0) {
                    this.saveRegion(r.data.data);
                }
            });
        },
        checkMobile(formName) {
            this.$refs[formName].validateField('mobile', (mobileError) => {
              if (!mobileError) {
                // 显示滑动验证码
                this.captchaMode = 'SEND_SMS';
                this.isShowSelf = true;
                this.$nextTick(() => {
                  this.$refs['slideCaptcha']?.refresh();
                });
              }
            });
        },
        checkForgetPassForm() {
            if (!this.forgetForm.phone) {
                this.$message.warning("请输入手机号");
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.forgetForm.phone)) {
                this.$message.warning("请输入正确的手机号");
                return;
            }
            if (!this.forgetForm.name) {
                this.$message.warning("请输入用户名");
                return;
            }
            this.captchaMode = 'FORGET_PASS_SMS';
            this.isShowSelf = true;
            this.$nextTick(() => {
                this.$refs['slideCaptcha']?.refresh();
            });
        },
        sendForgetPassCode(captchaId, moveX) {
            if (!this.isForgetSmsSend) return;
            this.isForgetSmsSend = false;
            this.forgetSmsInterval = "发送中...";
            userApi.sendForgetPassCode({
                name: this.forgetForm.name,
                phone: this.forgetForm.phone,
                captchaId: captchaId,
                captchaMove: moveX
            }).then((r) => {
                if (r.data.result === 0) {
                    this.forgetForm.token = r.data.data;
                    this.forgetSmsIntervalMethod();
                } else {
                    this.resetForgetSmsButton();
                }
            }).catch(() => {
                this.resetForgetSmsButton();
            });
        },
        forgetSmsIntervalMethod() {
            let smsIntervalTime = 60;
            if (this.forgetSmsTimer) {
                clearInterval(this.forgetSmsTimer);
            }
            this.forgetSmsTimer = setInterval(() => {
                if (smsIntervalTime <= 1) {
                    this.resetForgetSmsButton();
                } else {
                    smsIntervalTime -= 1;
                    this.forgetSmsInterval = `${smsIntervalTime}秒后再发`;
                }
            }, 1000);
        },
        resetForgetSmsButton() {
            if (this.forgetSmsTimer) {
                clearInterval(this.forgetSmsTimer);
                this.forgetSmsTimer = null;
            }
            this.forgetSmsInterval = "发送验证码";
            this.isForgetSmsSend = true;
        },
        resetForgetForm() {
            this.forgetNewPassword = "";
            this.forgetForm = {
                phone: "",
                name: "",
                token: "",
                code: ""
            };
            this.resetForgetSmsButton();
        },
        sendSms(captchaId, moveX) {
            if (!this.isSend) return;
            this.isSend = false;
            this.smsInterval = "发送中...";
            mechanismApi.sendVerifyCode({
                phone: '+86' + this.loginData.mobile,
                template: "login-by-mobile",
                captchaId: captchaId,
                captchaMove: moveX
            }).then((r) => {
                if (r.data.result === 0) {
                    this.loginData.token = r.data.data
                    this.smsIntervalMethod();
                } else if (r.data.result === 400){
                  this.$message.warning("请正确拼合图像");
                  this.smsInterval = "获取验证码";
                  this.isSend = true;
                }else {
                    this.smsInterval = "获取验证码";
                    this.isSend = true;
                }
            }).catch(error => {

              this.smsInterval = "获取验证码";
              this.isSend = true;
            });
        },
        switchLoginMode(loginMode) {
            this.loginData.mode = loginMode;
        },
        smsIntervalMethod() {
            let smsIntervalTime = 60;
            let timer = setInterval(() => {
                if (smsIntervalTime <= 1) {
                    clearInterval(timer);
                    this.smsInterval = "获取验证码";
                    this.isSend = true; // 重新回复点击发送功能的条件
                } else {
                    smsIntervalTime -= 1;
                    this.smsInterval = `${smsIntervalTime}秒后再发`;
                }
            }, 1000);
        },
        checkLoginForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                  this.captchaMode = this.loginData.mode;
                  this.isShowSelf = true;

                  setTimeout(() => {
                    this.$refs['slideCaptcha']?.refresh()
                  }, 0)

                }
            })
        },
        onCaptchaSuccess(data){
          this.isShowSelf = false;
          try{
            const mode = this.captchaMode;
            if (mode === "USER_NAME") {
              this.loginByUserName(data.captchaId, data.moveX);
            } else if (mode === "MOBILE") {
              this.loginByMobile(data.captchaId, data.moveX);
            } else if (mode === 'SEND_SMS'){
              this.sendSms(data.captchaId, data.moveX);
            } else if (mode === 'FORGET_PASS_SMS') {
              this.sendForgetPassCode(data.captchaId, data.moveX);
            }
          }finally {
            this.captchaMode = '';
          }
        },
        loginByUserName(captchaId, moveX) {
            ssoApi.login2({...this.loginData, ...{captchaId: captchaId, captchaMove: moveX}}).then(r => {
                if (r.data.result === 0) {
                    const { userDetail } = r.data.data;

                    const returnUrl = this.$route.query.returnUrl;
                    if(returnUrl && returnUrl.includes('jd.hebjlzy.com')){
                      //行政单位用户
                      const isXZDW = userDetail.organizationType.indexOf('0002') > -1;
                      if(isXZDW){
                        this.$message.error('当前用户为行政单位用户，请点击市监局用户登录进行登录');
                        return;
                      }
                    }

                    this.changeLogin(r.data.data);
                    // 是注册用户 或者是 单位管理员
                    const isRegisterUser = userDetail.type === 3 || userDetail.type === 1;
                    this.listUserRights(0, isRegisterUser);
                }
            })
        },
        loginByMobile(captchaId, moveX) {
            ssoApi.loginByMobile(this.loginData.mobile, this.loginData.code, this.loginData.token, captchaId, moveX).then((r) => {
                if (r.data.result === 0) {
                    const { userDetail } = r.data.data;
                    const returnUrl = this.$route.query.returnUrl;
                    if(returnUrl && returnUrl.includes('jd.hebjlzy.com')){
                      //行政单位用户
                      const isXZDW = userDetail.organizationType.indexOf('0002') > -1;
                      if(isXZDW){
                        this.$message.error('当前用户为行政单位用户，请点击市监局用户登录进行登录');
                        return;
                      }
                    }
                    this.changeLogin(r.data.data);
                    // 是注册用户 或者是 单位管理员
                    const isRegisterUser = userDetail.type === 3 || userDetail.type === 1;

                    this.listUserRights(0, isRegisterUser);
                }
            });
        },
        onChangeUserPwdSuccess(data){
          const { userDetail } = data;
          this.changeLogin(data);
          // 是注册用户 或者是 单位管理员
          const isRegisterUser = userDetail.type === 3 || userDetail.type === 1;
          this.listUserRights(0, isRegisterUser);
        },
        listUserRights(pageType, isRegisterUser) {
            TagsViewModule.delAllViews();
            TagsViewModule.delAllCachedViews();
            userApi.listUserRights(pageType).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    this.changeUserRight(rData);
                    const appId = this.$route.query.appId;
                    const returnUrl = this.$route.query.returnUrl;

                    if (appId && returnUrl && !isRegisterUser) {
                        this.getCode(appId, returnUrl);
                    } else {
                        this.$router.push("/list");
                    }
                }
            })
        },
        getCode(appId, returnUrl) {
            userApi.obtainCode({appId: appId}).then(r => {
                if (r.data.result == 0) {
                    const code = r.data.data;
                    window.location.href = (returnUrl + (returnUrl.includes("?") ? '&code=' : '?code=') + code);
                } else {
                    this.newLoadingShow = false;
                }
            })
        },
        saveBtn() {
            let form = this.$refs.form;
            form.validate((valid) => {
                if (valid) {
                    userApi.forgetPassByCode(this.forgetForm).then(r => {
                        if (r.data.result === 0) {
                            this.forgetNewPassword = r.data.data;
                            this.$message.success("密码重置成功，请使用新密码登录");
                        }
                    })
                }
            })
        },
        saveBtnLegacy() {
            let form = this.$refs.form;
            form.validate((valid) => {
                if (valid) {
                    userApi.forgetPass(this.forgetForm).then(r => {
                        if (r.data.result === 0) {
                            this.$message.success("稍后新密码将以短信的形式发送到您的手机");
                            this.forgetDialog = false;
                        }
                    })
                }
            })
        },

        //操作手册弹射
        ballMove() {
            if (this.positionX + this.shouceBtnSize.w >= this.screenWidth || this.positionX < 0) {//防止飞出div
                this.directX = -this.directX;//当要飞出div的时候 调整方向为反方向
            }
            if (this.positionY + this.shouceBtnSize.h >= this.screenHeight || this.positionY < 0) {
                this.derectY = -this.derectY;
            }
            this.positionX += 1 * this.directX;
            this.positionY += 1 * this.derectY;
            this.shouceBtnSize.x = this.positionX + 'px';
            this.shouceBtnSize.y = this.positionY + 'px';

        },
        //操作按钮样式
        shouceBtnStyle() {
            return {
                left: this.shouceBtnSize.x,
                top: this.shouceBtnSize.y,
            }
        },
        //暂停移动
        stopMove() {
            clearInterval(this.ballMoveInterval);
        },
        //开始移动
        startMove() {
            this.ballMoveInterval = setInterval(this.ballMove, 10);
        },
        toGongXiangPingTai() {
            window.open("https://www.hebjlzy.com/front/#/");
        },
        toGongZhongChaXun(){
          window.open("https://im.hebjlzy.com/mp/search/index.html");
        },
        goChangeMobile() {
            this.$router.push("/change-mobile");
        },
        goChangeApply() {
            this.$router.push("/change-mechanism-select");
        },
        openShiPin() {
            debugger;
            this.shouceShiPin.dialog = true;
        },
        //打开操作手册
        openShouCe() {
            this.shouceDialog = true;
        },
        downloadShouCe(row) {
            if (row.name === '3 强检计量器具台账器具信息填写指南') {
                console.log("123");
            } else {
                window.open(baseUrl + "/file/download?file=/shoucePDF/" + row.name + "&name=" + row.name, '_blank');
            }
        },
        downloadChangJianWenTi() {
            window.open(baseUrl + "/file/download?file=/shoucePDF/常见问题解答（一）.pdf&name=常见问题解答（一）.pdf", '_blank');
        },
        downloadCaoZuoZhiYin() {
            window.open(baseUrl + "/file/download?file=/shoucePDF/计量业务应用平台-诚信计量申请单位用户操作指引.pdf&name=计量业务应用平台-诚信计量申请单位用户操作指引.pdf", '_blank');
        },
        toZhiNengWenDa() {
            window.open("https://www.hebjlzy.com/front/#/intelligentQa/toIntelligentQaIndex", '_blank');
        },
        toVideo(videoUrl) {
            window.open(imageUrl + videoUrl);
        }

    }
}
</script>
